export default __webpack_public_path__ + "static/parigi-plus-lite-3-af01a9bfb92b13f7c3747a7338840762.jpg";